<script>
import EntryMenusSearch from './EntryMenusSearch'
import EmptyPng from '@/assets/empty.png'
import { i18nRender } from '@/locales'

export default {
  name: 'EntryMenusItem',
  components: {
    EntryMenusSearch
  },
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    tabActiveKey: {
      type: String,
      default: ''
    },
    menu: {
      type: Object,
      default: () => {}
    },
    tapPosition: {
      type: String,
      default: 'left'
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  data () {
    return {
      activeKey: '',
      image: EmptyPng
    }
  },
  watch: {
    menu: {
      handler: 'init',
      immediate: true
    }
  },
  computed: {
    favoriteKeys () {
      return this.favorites.map(item => item.key)
    }
  },
  methods: {
    addFavorites (key) {
      this.$store.dispatch('entry/AddFavorites', { key })
        .then(() => {
          this.$notification.success({
            message: this.$t('layouts.bookmarks.success')
            // '成功添加收藏'
          })
        })
    },
    delFavorites (key) {
      this.$store.dispatch('entry/DelFavorites', { key })
        .then(() => {
          this.$notification.success({
            message: this.$t('layouts.bookmarks.cancel')
            // '成功取消收藏'
          })
        })
    },
    init () {
      const { menu } = this
      this.activeKey = (menu && menu.childMenus && menu.childMenus.length && menu.childMenus[0].key) || ''
    },
    handleClick (key) {
      this.$emit('click', key, { statisticsType: 2, searchKey: '' })
    },
    handleClickTab (key, pushpin) {
      this.$emit('pushpin', {
        key,
        pushpin
      })
    },
    handleActiveTab (key) {
      this.activeKey = key
    },
    itemRender (menu) {
      const { handleClick, currentLang, tabActiveKey, favoriteKeys, addFavorites, delFavorites } = this
      const { childMenus, key, tab, menuName, platformExpireTime, assetsExpireTime, updateFlag } = menu
      const menutab = menuName?.[currentLang] || tab
      const menusItem = (childMenus && childMenus.length && childMenus.map(this.itemRender)) || null
      const isExpire = (platformExpireTime && Date.now() > Date.parse(platformExpireTime)) ||
                       (assetsExpireTime && Date.now() > Date.parse(assetsExpireTime)) ||
                       false
      const isFavorite = ~favoriteKeys.indexOf(key)
      let menuClass = 'entry-menus-item'
      menuClass += key === tabActiveKey ? ' entry-menus-item--active' : ''
      menuClass += menusItem ? '' : ' entry-menus-item--link'
      if (updateFlag === 2) return false
      return menusItem
        ? (
          <div class={menuClass} data-menu-key={key}>
            <div class="entry-menus-item__title">{menutab}</div>
            <div class="entry-menus-item__children">{menusItem}</div>
          </div>
        )
        : (
          <div class={menuClass} data-menu-key={key}>
            <a class="entry-menus-item__title">
              <div
                class="entry-menus-item__title__main"
                platformExpireTime={platformExpireTime}
                assetsExpireTime={assetsExpireTime}
                {...{ on: { click: handleClick.bind(this, key) } }}
              >{menutab}</div>
              { isExpire ? (<a-tag color="orange" style="display:none;">{ i18nRender('layouts.expired') }</a-tag>) : null}
              { isFavorite
                ? (<a-icon type="star" theme="filled" style="display:block;color:#077bfc;" {...{ on: { click: delFavorites.bind(this, key) } }} />)
                : (<a-icon type="star" {...{ on: { click: addFavorites.bind(this, key) } }} />)
              }
            </a>
          </div>
        )
    },
    getItemLength (menu) {
      let childrenLength = 0

      if (menu.childMenus && menu.childMenus.length) {
        childrenLength = menu.childMenus.reduce((total, item) => {
          return total + this.getItemLength(item)
        }, menu.childMenus.length)
      }

      return childrenLength
    },
    contentRender (menu) {
      const { getItemLength, itemRender } = this

      const item1 = { list: [], length: 0 }
      const item2 = { list: [], length: 0 }
      const item3 = { list: [], length: 0 }
      const item4 = { list: [], length: 0 }

      menu.childMenus && menu.childMenus.filter(find => find.updateFlag === 1).map(item => {
        const length = getItemLength(item)
        let obj = item1

        obj = obj.length > item2.length ? item2 : obj
        obj = obj.length > item3.length ? item3 : obj
        obj = obj.length > item4.length ? item4 : obj

        obj.list.push(item)
        obj.length += length
      })

      return !item1.length && !item2.length && !item3.length && !item4.length
        ? (
          <div class="entry-menus-content-2">
            <div class="entry-menus-col">{itemRender(menu)}</div>
          </div>
        )
        : (
          <div class="entry-menus-content-2">
            { item1.length || item1.list.length ? (<div class="entry-menus-col">{item1.list.map(itemRender)}</div>) : '' }
            { item2.length || item2.list.length ? (<div class="entry-menus-col">{item2.list.map(itemRender)}</div>) : '' }
            { item3.length || item3.list.length ? (<div class="entry-menus-col">{item3.list.map(itemRender)}</div>) : '' }
            { item4.length || item4.list.length ? (<div class="entry-menus-col">{item4.list.map(itemRender)}</div>) : '' }
          </div>
        )
    },
    tabsRender (menu) {
      const { activeKey, handleClickTab, handleActiveTab, contentRender, tapPosition, currentLang } = this
      const tabClassName = `entry-menus-tabs entry-menus-tabs--${tapPosition}`

      return (
        <div class={tabClassName}>
          <div class="entry-menus-tabs-nav">
            {
              menu.childMenus.map(item => {
                const { tab, menuName, key, pushpin } = item
                const menutab = menuName?.[currentLang] || tab
                const itemClassName = activeKey === key
                  ? 'entry-menus-tabs-tab entry-menus-tabs-tab--active'
                  : 'entry-menus-tabs-tab'
                const menuIcon = pushpin ? (<a-icon type="pushpin" theme="filled" style="margin-left:10px;display:inline-block;font-size:12px;vertical-align:baseline;" />) : (<icon-font type="gb-icon-push-pin--line" style="margin-left:10px;" />)

                return (
                  <section
                    class={itemClassName}
                    { ...{ on: {
                      click: handleClickTab.bind(this, key, pushpin),
                      mouseover: handleActiveTab.bind(this, key)
                    } } }
                  >
                    <div class="entry-menus-tabs-tab__label">
                      <span>{menutab}</span>
                      {menuIcon}
                    </div>
                  </section>
                )
              })
            }
          </div>
          <div class="entry-menus-tabs-content">
            {
              menu.childMenus.map(item => {
                const className = activeKey === item.key
                  ? 'entry-menus-tabs-tabpane entry-menus-tabs-tabpane--active'
                  : 'entry-menus-tabs-tabpane'
                return (<section class={className}>{contentRender(item)}</section>)
              })
            }
          </div>
        </div>
      )
    }
  },
  render () {
    const { currentLang, menu, image, contentRender, tabsRender, handleClick } = this
    let template = (<a-empty image={image} description={i18nRender('layouts.text.undefined')} />)

    if (menu) {
      switch (menu.special) {
        case 1:
          template = contentRender(menu)
          break
        case 2:
          template = tabsRender(menu)
          break
        case 3:
          template = (<EntryMenusSearch menus={[menu]} currentLang={currentLang} { ...{ on: { click: handleClick } } } />)
          break
      }
    }

    return template
  }
}
</script>

<style lang="less" scoped>
.entry-menus-content-2 {
  margin-top: -4px;
  padding-left: 22px;
  padding-top: 22px;
  display: flex;
  max-width: 100vw;
  background: #ffffff;
}

.entry-menus-col {
  margin-bottom: 15px;
  padding-right: 22px;
  width: 25%;
  min-width: 150px;

  > .entry-menus-item {
    margin-bottom: 8px;

    > .entry-menus-item__title {
      margin-bottom: 8px;
      box-shadow: inset 0 -1px #eee;
      font-size: 14px;
      font-weight: bold;
      position: relative;

      &::after {
        content: " ";
        width: 60px;
        max-width: 100%;
        border-bottom: 1px solid #077bfc;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}

.entry-menus-item__title {
  padding-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .anticon {
    display: none;
  }

  &:hover {
    .anticon {
      display: block;
    }
  }
}

a.entry-menus-item__title {
  padding: 0;
  display: flex;
  align-items: center;

  &:hover {
    color: #5682F4!important;
    background-color: #F6F7FA;
  }

  .entry-menus-item__title__main {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .@{ant-prefix}-tag {
    margin: 0;
    margin-left: 8px;
    line-height: 15px;
  }
}

.entry-menus-item__children {
  .entry-menus-item__title {
    color: #333;
    font-size: 12px;
    line-height: 28px;
  }
  .entry-menus-item__children {
    margin-bottom: 5px;
    padding: 8px 8px 8px 13px;
    background: #F6F7FA;
    border-radius: 2px;
    position: relative;

    &::before {
      content: " ";
      display: block;
      width: 8.48528137px;
      height: 8.48528137px;
      border-color: #F6F7FA;
      border-style: solid;
      border-width: 4.24264069px;
      position: absolute;
      left: 14px;
      top: -4px;
      transform: rotate(45deg);
    }

    .entry-menus-item__title {
      color: #666;
    }
  }
}

.entry-menus-tabs {
  margin-top: -4px;
  display: flex;
  background: #fff;
  border-radius: 0 0 4px 4px;
  box-shadow: 1px 3px 6px 1px rgba(0, 0, 0, 0.15);
  max-height: 100%;
  overflow: hidden;

  .entry-menus-content-2 {
    margin-top: 0;
    box-shadow: none;
    max-width: 100%;
    max-height: 100%;
  }
}
.entry-menus-tabs-nav {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  overflow: auto;
}
.entry-menus-tabs-tab {
  padding: 10px 5px;
  position: relative;
  cursor: pointer;

  &__label {
    padding: 0 10px;
    display: block;
    background: #F6F7FA no-repeat center center;
    min-width: 110px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 2px;
    border: 1px solid #F6F7FA;
  }

  .anticon {
    display: none;
  }
}

.entry-menus-tabs-tab--active {
  .entry-menus-tabs-tab__label {
    color: #077bfc;
    position: relative;
  }

  &::after {
    content: " ";
    display: block;
    width: 8.48528137px;
    height: 8.48528137px;
    background: #F6F7FA;
    border-style: solid;
    border-width: 4.24264069px;
    border-color: #F6F7FA;
    position: absolute;
    right: 11px;
    top: 50%;
    -webkit-transform: translateY(-50%) rotate(45deg);
    transform: translateY(-50%) rotate(45deg);
  }

  .anticon {
    display: inline-block;
  }
}
.entry-menus-tabs-content {
  width: 800px;
  max-width: calc(100vw - 160px);
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: auto;
}
.entry-menus-tabs-tabpane {
  display: none;

  &--active {
    display: block;
  }
}

// tab-postion-left
.entry-menus-tabs--left {
  .entry-menus-tabs-nav {
    padding: 15px 0;
  }
}
// tab-postion-top
.entry-menus-tabs--top {
  flex-direction: column;

  .entry-menus-tabs-nav {
    margin-bottom: -15px;
    padding: 0 5px;
    flex-direction: row;
    background: #ffffff;
    z-index: 1;
  }

  .entry-menus-tabs-tab--active::after {
    top: auto;
    left: 50%;
    bottom: 6px;
    -webkit-transform: translateX(-50%) rotate(45deg);
    transform: translateX(-50%) rotate(45deg);
  }
}
.entry-menus-item--active {
  > .entry-menus-item__title {
    margin-left: -8px;
    padding-left: 8px;
    background-color: #077bfc;
    color: #fff!important;

    &::after {
      display: none;
    }
  }
}

.entry-menus-item--link {
  margin-bottom: 0!important;

  .entry-menus-item__title {
    margin-bottom: 0!important;
    box-shadow: none!important;

    &::after {
      display: none!important;
    }
  }

  .entry-menus-item__title__main {
    color: #333;
    font-size: 12px!important;
    font-weight: 400!important;
    box-shadow: none!important;
  }
}
</style>
